/**
 * @file Created on Thu Sep 27 2018
 * @author LZe
 */
import Messages from './Messages';
export default Messages;